module.exports = __webpack_public_path__ + "static/media/javascript.d4226a38.svg";